import { render, staticRenderFns } from "./CajeroIndex.vue?vue&type=template&id=0ae37472&scoped=true"
import script from "./CajeroIndex.vue?vue&type=script&lang=ts"
export * from "./CajeroIndex.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ae37472",
  null
  
)

export default component.exports